import { getAuthIdToken } from "@/lib/firebase";
import axios from "axios";

const csRagInstance = axios.create({
  baseURL: `${import.meta.env.VITE_CS_RAG_API_URL}`,
  timeout: 120_000,
  headers: { "Content-Type": "application/json" },
});

csRagInstance.interceptors.request.use(async (config) => {
  const idToken = await getAuthIdToken();
  if (idToken) {
    config.headers.Authorization = `Bearer ${idToken}`;
  }
  return config;
});

export default csRagInstance;
